const copy: Record<string, readonly string[]> = {
  "en": [
    "Start at the charger you are plugged into",
    "Scan the QR code on your charger, select your connector and check the price. We will not guess which car is yours.",
    "Scan my charger",
    "I confirm this is my charger and connector, connected to my car, and I accept the price shown.",
    "Confirm your charger and connector before starting.",
    "Unable to safely move this start. Refresh your session or contact support."
  ],
  "fr": [
    "Démarrer sur la borne branchée à votre voiture",
    "Scannez le code QR de votre borne, choisissez votre connecteur et vérifiez le prix. Nous ne devinerons pas quelle voiture est la vôtre.",
    "Scanner ma borne",
    "Je confirme que cette borne et ce connecteur sont branchés à ma voiture et j’accepte le prix affiché.",
    "Confirmez votre borne et votre connecteur avant de démarrer.",
    "Impossible de déplacer ce démarrage en sécurité. Actualisez la session ou contactez l’assistance."
  ],
  "es": [
    "Iniciar en el cargador conectado a tu coche",
    "Escanea el código QR de tu cargador, selecciona tu conector y revisa el precio. No adivinaremos qué coche es tuyo.",
    "Escanear mi cargador",
    "Confirmo que este cargador y conector están conectados a mi coche y acepto el precio mostrado.",
    "Confirma tu cargador y conector antes de iniciar.",
    "No se puede cambiar este inicio de forma segura. Actualiza la sesión o contacta con soporte."
  ],
  "pt": [
    "Iniciar no carregador ligado ao seu carro",
    "Leia o código QR do seu carregador, selecione o conector e confira o preço. Não vamos adivinhar qual carro é seu.",
    "Ler meu carregador",
    "Confirmo que este carregador e conector estão ligados ao meu carro e aceito o preço apresentado.",
    "Confirme o carregador e o conector antes de iniciar.",
    "Não é possível mudar este início com segurança. Atualize a sessão ou contacte o suporte."
  ],
  "it": [
    "Avvia sul caricatore collegato alla tua auto",
    "Scansiona il codice QR del caricatore, seleziona il connettore e controlla il prezzo. Non indovineremo quale auto è tua.",
    "Scansiona il mio caricatore",
    "Confermo che questo caricatore e connettore sono collegati alla mia auto e accetto il prezzo indicato.",
    "Conferma caricatore e connettore prima di avviare.",
    "Impossibile spostare questo avvio in sicurezza. Aggiorna la sessione o contatta l’assistenza."
  ],
  "ru": [
    "Начать на зарядной станции вашего автомобиля",
    "Сканируйте QR-код станции, выберите разъём и проверьте цену. Мы не будем угадывать, какой автомобиль ваш.",
    "Сканировать мою станцию",
    "Подтверждаю, что эта станция и разъём подключены к моей машине, и принимаю указанную цену.",
    "Подтвердите станцию и разъём перед запуском.",
    "Невозможно безопасно перенести запуск. Обновите сеанс или обратитесь в поддержку."
  ],
  "uk": [
    "Почати на станції, підключеній до вашого авто",
    "Скануйте QR-код станції, виберіть роз’єм і перевірте ціну. Ми не вгадуватимемо, яке авто ваше.",
    "Сканувати мою станцію",
    "Підтверджую, що ця станція та роз’єм підключені до мого авто, і приймаю вказану ціну.",
    "Підтвердьте станцію та роз’єм перед запуском.",
    "Неможливо безпечно перенести запуск. Оновіть сеанс або зверніться до підтримки."
  ],
  "zh": [
    "在连接您车辆的充电桩上启动",
    "扫描充电桩二维码，选择充电接口并核对价格。我们不会猜测哪辆车是您的。",
    "扫描我的充电桩",
    "我确认此充电桩和接口连接着我的车辆，并接受显示的价格。",
    "启动前请确认充电桩和接口。",
    "无法安全转移此次启动。请刷新会话或联系支持。"
  ],
  "ja": [
    "車に接続した充電器で開始",
    "充電器のQRコードを読み取り、コネクターを選んで料金を確認してください。車の所有者を推測することはありません。",
    "充電器をスキャン",
    "この充電器とコネクターが自分の車に接続されており、表示料金に同意することを確認します。",
    "開始前に充電器とコネクターを確認してください。",
    "安全に開始先を変更できません。セッションを更新するかサポートにお問い合わせください。"
  ],
  "ko": [
    "내 차량에 연결된 충전기에서 시작",
    "충전기의 QR 코드를 스캔하고 커넥터와 요금을 확인하세요. 어느 차량이 본인 차량인지 추측하지 않습니다.",
    "내 충전기 스캔",
    "이 충전기와 커넥터가 내 차량에 연결되어 있으며 표시된 요금에 동의합니다.",
    "시작하기 전에 충전기와 커넥터를 확인하세요.",
    "안전하게 시작 위치를 변경할 수 없습니다. 세션을 새로고침하거나 지원팀에 문의하세요."
  ],
  "hy": [
    "Սկսեք ձեր մեքենային միացված լիցքավորիչով",
    "Սկանավորեք լիցքավորիչի QR կոդը, ընտրեք միակցիչը և ստուգեք գինը։ Մենք չենք գուշակի, թե որ մեքենան է ձերը։",
    "Սկանավորել իմ լիցքավորիչը",
    "Հաստատում եմ, որ այս լիցքավորիչն ու միակցիչը միացված են իմ մեքենային, և ընդունում եմ նշված գինը։",
    "Սկսելուց առաջ հաստատեք լիցքավորիչն ու միակցիչը։",
    "Անհնար է անվտանգ փոխել մեկնարկը։ Թարմացրեք սեանսը կամ դիմեք աջակցությանը։"
  ]
};
export const recoveryText = (locale: string, index: number): string => (copy[locale.split('-')[0] ?? 'en'] ?? copy.en)![index]!;
